import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { mapTo, switchMap, tap } from "rxjs/operators";
import { SsoAccountRemote } from "../../infrastructure/sso-account.remote";
import { SsoAccountCheckoutState, SsoAccountData } from "../models/sso-account.model";
import { SsoAccountStateService } from "./sso-account.state.service";

@Injectable({
  providedIn: "root",
})
export class SsoAccountFacade {
  constructor(
    private readonly stateService: SsoAccountStateService,
    private readonly remote: SsoAccountRemote
  ) { }

  getCurrentSsoAccount$(): Observable<SsoAccountData> {
    if (this.stateService.isCurrentSsoAccountStateLoaded()) {
      return this.stateService.getCurrentSsoAccount$();
    }
    return this.refreshCurrentSsoAccount().pipe(
      switchMap(() => this.stateService.getCurrentSsoAccount$())
    );
  }

  refreshCurrentSsoAccount(): Observable<void> {
    return this.remote.getCurrent().pipe(
      tap((data: SsoAccountData) => this.stateService.setCurrentSsoAccount(data)),
      mapTo(undefined)
    );
  }

  getSsoAccountCheckoutState$(): Observable<SsoAccountCheckoutState> {
    if (this.stateService.isSsoAccountCheckoutStateLoaded()) {
      return this.stateService.getSsoAccountCheckoutState$();
    }
    return this.refreshSsoAccountCheckoutState().pipe(
      switchMap(() => this.stateService.getSsoAccountCheckoutState$())
    );
  }

  refreshSsoAccountCheckoutState(): Observable<void> {
    return this.remote.getCheckoutState().pipe(
      tap((details: SsoAccountCheckoutState) =>
        this.stateService.setSsoAccountCheckoutState(details)
      ),
      mapTo(undefined)
    );
  }

  clearSsoAccountCache(): void {
    return this.stateService.clearState();
  }
}
